// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */
/**
 * 1. Change the default font family in all browsers (opinionated).
 * 2. Correct the line height in all browsers.
 * 3. Prevent adjustments of font size after orientation changes in
 *    IE on Windows Phone and in iOS.
 */
/* Document
   ========================================================================== */
html {
  font-family: sans-serif;
  /* 1 */
  line-height: 1.15;
  /* 2 */
  -ms-text-size-adjust: 100%;
  /* 3 */
  -webkit-text-size-adjust: 100%;
  /* 3 */
}
/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers (opinionated).
 */
body {
  margin: 0;
}
/**
 * Add the correct display in IE 9-.
 */
article,
aside,
footer,
header,
nav,
section {
  display: block;
}
/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
/* Grouping content
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 * 1. Add the correct display in IE.
 */
figcaption,
figure,
main {
  /* 1 */
  display: block;
}
/**
 * Add the correct margin in IE 8.
 */
figure {
  margin: 1em 40px;
}
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}
/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}
/* Text-level semantics
   ========================================================================== */
/**
 * 1. Remove the gray background on active links in IE 10.
 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
 */
a {
  background-color: transparent;
  /* 1 */
  -webkit-text-decoration-skip: objects;
  /* 2 */
}
/**
 * Remove the outline on focused links when they are also active or hovered
 * in all browsers (opinionated).
 */
a:active,
a:hover {
  outline-width: 0;
}
/**
 * 1. Remove the bottom border in Firefox 39-.
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}
/**
 * Prevent the duplicate application of \`bolder\` by the next rule in Safari 6.
 */
b,
strong {
  font-weight: inherit;
}
/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}
/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}
/**
 * Add the correct font style in Android 4.3-.
 */
dfn {
  font-style: italic;
}
/**
 * Add the correct background and color in IE 9-.
 */
mark {
  background-color: #ff0;
  color: #000;
}
/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}
/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/* Embedded content
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 */
audio,
video {
  display: inline-block;
}
/**
 * Add the correct display in iOS 4-7.
 */
audio:not([controls]) {
  display: none;
  height: 0;
}
/**
 * Remove the border on images inside links in IE 10-.
 */
img {
  border-style: none;
}
/**
 * Hide the overflow in IE.
 */
svg:not(:root) {
  overflow: hidden;
}
/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers (opinionated).
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: sans-serif;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}
/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}
/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}
/**
 * 1. Prevent a WebKit bug where (2) destroys native \`audio\` and \`video\`
 *    controls in Android 4.
 * 2. Correct the inability to style clickable types in iOS and Safari.
 */
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
  /* 2 */
}
/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}
/**
 * Change the border, margin, and padding in all browsers (opinionated).
 */
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}
/**
 * 1. Add the correct display in IE 9-.
 * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  display: inline-block;
  /* 1 */
  vertical-align: baseline;
  /* 2 */
}
/**
 * Remove the default vertical scrollbar in IE.
 */
textarea {
  overflow: auto;
}
/**
 * 1. Add the correct box sizing in IE 10-.
 * 2. Remove the padding in IE 10-.
 */
[type="checkbox"],
[type="radio"] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}
/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type="search"] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}
/**
 * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
 */
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}
/* Interactive
   ========================================================================== */
/*
 * Add the correct display in IE 9-.
 * 1. Add the correct display in Edge, IE, and Firefox.
 */
details,
menu {
  display: block;
}
/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}
/* Scripting
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 */
canvas {
  display: inline-block;
}
/**
 * Add the correct display in IE.
 */
template {
  display: none;
}
/* Hidden
   ========================================================================== */
/**
 * Add the correct display in IE 10-.
 */
[hidden] {
  display: none;
}
.chat-sidebar {
  position: absolute;
  right: 0;
  width: 300px;
  height: 100%;
  background: #EFEEF1;
}
.hashtag-sidebar {
  position: absolute;
  left: 0;
  width: 300px;
  height: 100%;
}
.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 64px;
  bottom: 0px;
}
.content.leave-right-margin {
  margin-right: 300px;
}
.content.leave-left-margin {
  margin-left: 300px;
}
.no-webcasts-container {
  max-width: 800px;
  height: 100%;
  margin: auto;
  padding: 0 15px;
  overflow-x: hidden;
  overflow-y: auto;
  color: white;
  text-align: center;
}
.no-webcasts-container > * {
  margin-bottom: 69px;
}
.video-js {
  width: 100% !important;
  height: 100% !important;
}
.livescore-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.livescore-container {
  margin: 0 auto;
}
.livescore-display {
  width: 400px;
  padding: 15px;
  text-align: center;
  color: white;
}
.livescore-display h3 {
  margin-top: 0;
}
.livescore-display .col-container {
  display: flex;
  flex-direction: row;
}
.livescore-display .side-col {
  flex-grow: 1;
}
.livescore-display .mid-col {
  flex-grow: 1;
  padding: 0 10px;
}
.livescore-display .booleanIndicator {
  border: solid 1px #ccc;
  border-radius: 3px;
  margin-bottom: 8px;
  background-color: #222;
}
.livescore-display .powerupsContainer {
  display: flex;
  margin-bottom: 8px;
}
.livescore-display .powerupCountContainer {
  flex: 1;
  border: solid 1px #ccc;
  border-radius: 3px;
  padding: 3px;
  background-color: #222;
}
.livescore-display .powerupCountContainerCenter {
  margin-left: 3px;
  margin-right: 3px;
}
.livescore-display .powerupIcon {
  height: 25px;
  width: 25px;
  margin: 0;
  image-rendering: optimizeSpeed;
  /* STOP SMOOTHING, GIVE ME SPEED  */
  image-rendering: -moz-crisp-edges;
  /* Firefox                        */
  image-rendering: -o-crisp-edges;
  /* Opera                          */
  image-rendering: -webkit-optimize-contrast;
  /* Chrome (and eventually Safari) */
  image-rendering: pixelated;
  /* Chrome */
  image-rendering: optimize-contrast;
  /* CSS3 Proposed                  */
  -ms-interpolation-mode: nearest-neighbor;
  /* IE8+                           */
}
.livescore-display .powerCube {
  width: 12px;
  height: 12px;
  margin: 3px auto 0;
}
.livescore-display .powerCubeActive {
  background-color: #ffcf08;
  border: 1px solid #111;
  border-radius: 2px;
}
.livescore-display .timeRemainingContainer {
  width: 100%;
  position: absolute;
  left: 0;
}
.livescore-display .timeRemaining {
  background-color: rgba(63, 63, 63, 0.5);
  padding: 0 5px;
  border-radius: 3px;
}
.livescore-display .scoreContainer {
  display: flex;
  margin-bottom: 8px;
}
.livescore-display .redAlliance {
  flex: 1;
  margin-right: 2px;
}
.livescore-display .blueAlliance {
  flex: 1;
  margin-left: 2px;
}
.livescore-display .score {
  border: solid 1px #ccc;
  border-radius: 3px;
  font-size: 18px;
  font-weight: bold;
  padding: 1px;
  margin-top: 8px;
}
.livescore-display .currentPowerup {
  border: solid 1px #ccc;
  border-radius: 3px;
  font-size: 14px;
  margin: 0 auto;
  padding: 1px;
  width: 40px;
}
.livescore-display .currentPowerupIcon {
  width: 20px;
  height: 20px;
  margin: 2px auto;
  image-rendering: optimizeSpeed;
  /* STOP SMOOTHING, GIVE ME SPEED  */
  image-rendering: -moz-crisp-edges;
  /* Firefox                        */
  image-rendering: -o-crisp-edges;
  /* Opera                          */
  image-rendering: -webkit-optimize-contrast;
  /* Chrome (and eventually Safari) */
  image-rendering: pixelated;
  /* Chrome */
  image-rendering: optimize-contrast;
  /* CSS3 Proposed                  */
  -ms-interpolation-mode: nearest-neighbor;
  /* IE8+                           */
}
.livescore-display .blue {
  background-color: #0066FF;
}
.livescore-display .red {
  background-color: #FF0000;
}
.livescore-display .progress {
  height: 20px;
  margin-bottom: 8px;
  border: solid 1px #ccc;
  border-radius: 3px;
  background-color: #222;
}
.livescore-display .progress-bar {
  float: left;
  height: 100%;
  border-radius: 2px;
}
.livescore-display .progress-bar-red {
  background-color: red;
}
.livescore-display .progress-bar-yellow {
  background-color: yellow;
}
.livescore-display .progress-bar-green {
  background-color: green;
}
@keyframes highlightRed1 {
  0% {
    background-color: #880000;
  }
  100% {
    background-color: #222;
  }
}
@keyframes highlightRed2 {
  0% {
    background-color: #880000;
  }
  100% {
    background-color: #222;
  }
}
@keyframes highlightRed3 {
  0% {
    background-color: #880000;
  }
  100% {
    background-color: #222;
  }
}
@keyframes highlightBlue1 {
  0% {
    background-color: #003388;
  }
  100% {
    background-color: #222;
  }
}
@keyframes highlightBlue2 {
  0% {
    background-color: #003388;
  }
  100% {
    background-color: #222;
  }
}
@keyframes highlightBlue3 {
  0% {
    background-color: #003388;
  }
  100% {
    background-color: #222;
  }
}
.livescore-display .redCount1 {
  animation: highlightRed1 1s ease-in-out;
}
.livescore-display .redCount2 {
  animation: highlightRed2 1s ease-in-out;
}
.livescore-display .redCount3 {
  animation: highlightRed3 1s ease-in-out;
}
.livescore-display .blueCount1 {
  animation: highlightBlue1 1s ease-in-out;
}
.livescore-display .blueCount2 {
  animation: highlightBlue2 1s ease-in-out;
}
.livescore-display .blueCount3 {
  animation: highlightBlue3 1s ease-in-out;
}
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
html {
  height: 100%;
}
body {
  background: black;
  height: 100%;
  font-family: 'Roboto', sans-serif;
}
#content {
  height: 100%;
  overflow: hidden;
}
.container-full {
  position: relative;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
#twitter-widget {
  height: 100%;
  background: white;
}
iframe[id^='twitter-widget-'] {
  height: 100% !important;
}
.layout-selection-panel {
  max-width: 800px;
  height: 100%;
  margin: auto;
  padding: 0 15px;
  overflow-x: hidden;
  overflow-y: auto;
  color: white;
}
.layout-selection-panel h1 {
  text-align: center;
}
.layout-selection-panel .layout-preview-container {
  text-align: center;
  padding-top: 20px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}
.layout-selection-panel .layout-preview-container:hover {
  transform: scale(1.1);
  z-index: 5;
}
.layout-selection-panel .layout-preview-container:active {
  transform: scale(1.2);
  z-index: 5;
}
.layout-selection-panel .layout-preview {
  width: 160px;
  height: 90px;
  position: relative;
  display: inline-block;
}
.layout-selection-panel div[class^="video-"] {
  background-color: white;
  padding: 1px;
  background-clip: content-box;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/gameday2/gameday2.less","webpack://./src/frontend/gameday2/normalize.less","webpack://./src/frontend/gameday2/sidebars.less","webpack://./src/frontend/gameday2/nowebcasts.less","webpack://./src/frontend/gameday2/videojs.less","webpack://./src/frontend/gameday2/livescore.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;;;;;EAKE;AACF;+EAC+E;ACI/E;EACE,uBAAA;EDFA,MAAM;ECGN,iBAAA;EDDA,MAAM;ECEN,0BAAA;EDAA,MAAM;ECCN,8BAAA;EDCA,MAAM;AACR;AACA;+EAC+E;AAC/E;;EAEE;ACGF;EACE,SAAA;ADDF;AACA;;EAEE;ACKF;;;;;;EAME,cAAA;ADHF;AACA;;;EAGE;ACOF;EACE,cAAA;EACA,gBAAA;ADLF;AACA;+EAC+E;AAC/E;;;EAGE;ACUF;;;EDNE,MAAM;ECSN,cAAA;ADPF;AACA;;EAEE;ACWF;EACE,gBAAA;ADTF;AACA;;;EAGE;ACaF;EACE,uBAAA;EDXA,MAAM;ECYN,SAAA;EDVA,MAAM;ECWN,iBAAA;EDTA,MAAM;AACR;AACA;;;EAGE;ACYF;EACE,iCAAA;EDVA,MAAM;ECWN,cAAA;EDTA,MAAM;AACR;AACA;+EAC+E;AAC/E;;;EAGE;ACaF;EACE,6BAAA;EDXA,MAAM;ECYN,qCAAA;EDVA,MAAM;AACR;AACA;;;EAGE;ACaF;;EAEE,gBAAA;ADXF;AACA;;;EAGE;ACeF;EACE,mBAAA;EDbA,MAAM;ECcN,0BAAA;EDZA,MAAM;ECaN,iCAAA;EDXA,MAAM;AACR;AACA;;EAEE;ACcF;;EAEE,oBAAA;ADZF;AACA;;EAEE;ACgBF;;EAEE,mBAAA;ADdF;AACA;;;EAGE;ACkBF;;;EAGE,iCAAA;EDhBA,MAAM;ECiBN,cAAA;EDfA,MAAM;AACR;AACA;;EAEE;ACkBF;EACE,kBAAA;ADhBF;AACA;;EAEE;ACoBF;EACE,sBAAA;EACA,WAAA;ADlBF;AACA;;EAEE;ACsBF;EACE,cAAA;ADpBF;AACA;;;EAGE;ACwBF;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ADtBF;ACyBA;EACE,eAAA;ADvBF;AC0BA;EACE,WAAA;ADxBF;AACA;+EAC+E;AAC/E;;EAEE;AC6BF;;EAEE,qBAAA;AD3BF;AACA;;EAEE;AC+BF;EACE,aAAA;EACA,SAAA;AD7BF;AACA;;EAEE;ACiCF;EACE,kBAAA;AD/BF;AACA;;EAEE;ACmCF;EACE,gBAAA;ADjCF;AACA;+EAC+E;AAC/E;;;EAGE;ACsCF;;;;;EAKE,uBAAA;EDpCA,MAAM;ECqCN,eAAA;EDnCA,MAAM;ECoCN,iBAAA;EDlCA,MAAM;ECmCN,SAAA;EDjCA,MAAM;AACR;AACA;;;EAGE;ACoCF;;EDjCE,MAAM;ECmCN,iBAAA;ADjCF;AACA;;;EAGE;ACqCF;;EDlCE,MAAM;ECoCN,oBAAA;ADlCF;AACA;;;;EAIE;ACsCF;;;;EAIE,0BAAA;EDpCA,MAAM;AACR;AACA;;EAEE;ACuCF;;;;EAIE,kBAAA;EACA,UAAA;ADrCF;AACA;;EAEE;ACyCF;;;;EAIE,8BAAA;ADvCF;AACA;;EAEE;AC2CF;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;ADzCF;AACA;;;;;EAKE;AC6CF;EACE,sBAAA;ED3CA,MAAM;EC4CN,cAAA;ED1CA,MAAM;EC2CN,cAAA;EDzCA,MAAM;EC0CN,eAAA;EDxCA,MAAM;ECyCN,UAAA;EDvCA,MAAM;ECwCN,mBAAA;EDtCA,MAAM;AACR;AACA;;;EAGE;ACyCF;EACE,qBAAA;EDvCA,MAAM;ECwCN,wBAAA;EDtCA,MAAM;AACR;AACA;;EAEE;ACyCF;EACE,cAAA;ADvCF;AACA;;;EAGE;AC2CF;;EAEE,sBAAA;EDzCA,MAAM;EC0CN,UAAA;EDxCA,MAAM;AACR;AACA;;EAEE;AC2CF;;EAEE,YAAA;ADzCF;AACA;;;EAGE;AC6CF;EACE,6BAAA;ED3CA,MAAM;EC4CN,oBAAA;ED1CA,MAAM;AACR;AACA;;EAEE;AC6CF;;EAEE,wBAAA;AD3CF;AACA;;;EAGE;AC+CF;EACE,0BAAA;ED7CA,MAAM;EC8CN,aAAA;ED5CA,MAAM;AACR;AACA;+EAC+E;AAC/E;;;EAGE;ACgDF;;EAEE,cAAA;AD9CF;AACA;;EAEE;ACkDF;EACE,kBAAA;ADhDF;AACA;+EAC+E;AAC/E;;EAEE;ACqDF;EACE,qBAAA;ADnDF;AACA;;EAEE;ACuDF;EACE,aAAA;ADrDF;AACA;+EAC+E;AAC/E;;EAEE;AC0DF;EACE,aAAA;ADxDF;AEhZA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AFkZF;AE/YA;EACE,kBAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;AFiZF;AE9YA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EAEA,SAAA;EACA,WAAA;AF+YF;AE9YE;EACE,mBAAA;AFgZJ;AE7YE;EACE,kBAAA;AF+YJ;AG7aA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AH+aF;AGvbA;EAUI,mBAAA;AHgbJ;AIzbA;EACE,sBAAA;EACA,uBAAA;AJ2bF;AK5bA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AL8bF;AK3bA;EACE,cAAA;AL6bF;AK1bA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AL4bF;AKhcA;EAOI,aAAA;AL4bJ;AKncA;EAWI,aAAA;EACA,mBAAA;AL2bJ;AKvcA;EAgBI,YAAA;AL0bJ;AK1cA;EAoBI,YAAA;EACA,eAAA;ALybJ;AK9cA;EAyBI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;ALwbJ;AKpdA;EAgCI,aAAA;EACA,kBAAA;ALubJ;AKxdA;EAqCI,OAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;ALsbJ;AK/dA;EA6CI,gBAAA;EACA,iBAAA;ALqbJ;AKneA;EAkDI,YAAA;EACA,WAAA;EACA,SAAA;EACA,8BAAA;ELobF,mCAAmC;EKnbjC,iCAAA;ELqbF,mCAAmC;EKpbjC,+BAAA;ELsbF,mCAAmC;EKrbjC,0CAAA;ELubF,mCAAmC;EKtbjC,0BAAA;ELwbF,WAAW;EKvbT,kCAAA;ELybF,mCAAmC;EKxbjC,wCAAA;EL0bF,mCAAmC;AACrC;AKtfA;EA+DI,WAAA;EACA,YAAA;EACA,kBAAA;AL0bJ;AK3fA;EAqEI,yBAAA;EACA,sBAAA;EACA,kBAAA;ALybJ;AKhgBA;EA2EI,WAAA;EACA,kBAAA;EACA,OAAA;ALwbJ;AKrgBA;EAiFI,uCAAA;EACA,cAAA;EACA,kBAAA;ALubJ;AK1gBA;EAuFI,aAAA;EACA,kBAAA;ALsbJ;AK9gBA;EA4FI,OAAA;EACA,iBAAA;ALqbJ;AKlhBA;EAiGI,OAAA;EACA,gBAAA;ALobJ;AKthBA;EAsGI,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;ALmbJ;AK9hBA;EA+GI,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;ALkbJ;AKtiBA;EAwHI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;ELibF,mCAAmC;EKhbjC,iCAAA;ELkbF,mCAAmC;EKjbjC,+BAAA;ELmbF,mCAAmC;EKlbjC,0CAAA;ELobF,mCAAmC;EKnbjC,0BAAA;ELqbF,WAAW;EKpbT,kCAAA;ELsbF,mCAAmC;EKrbjC,wCAAA;ELubF,mCAAmC;AACrC;AKzjBA;EAqII,yBAAA;ALubJ;AK5jBA;EAyII,yBAAA;ALsbJ;AK/jBA;EA6II,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;ALqbJ;AKtkBA;EAqJI,WAAA;EACA,YAAA;EACA,kBAAA;ALobJ;AK3kBA;EA2JI,qBAAA;ALmbJ;AK9kBA;EA+JI,wBAAA;ALkbJ;AKjlBA;EAmKI,uBAAA;ALibJ;AK9aE;EACE;IAAO,yBAAA;ELibT;EKhbE;IAAO,sBAAA;ELmbT;AACF;AKjbE;EACE;IAAO,yBAAA;ELobT;EKnbE;IAAO,sBAAA;ELsbT;AACF;AKpbE;EACE;IAAO,yBAAA;ELubT;EKtbE;IAAO,sBAAA;ELybT;AACF;AKxbE;EACE;IAAO,yBAAA;EL2bT;EK1bE;IAAO,sBAAA;EL6bT;AACF;AK3bE;EACE;IAAO,yBAAA;EL8bT;EK7bE;IAAO,sBAAA;ELgcT;AACF;AK9bE;EACE;IAAO,yBAAA;ELicT;EKhcE;IAAO,sBAAA;ELmcT;AACF;AKpoBA;EAoMI,uCAAA;ALmcJ;AKvoBA;EAwMI,uCAAA;ALkcJ;AK1oBA;EA4MI,uCAAA;ALicJ;AK7oBA;EAgNI,wCAAA;ALgcJ;AKhpBA;EAoNI,wCAAA;AL+bJ;AKnpBA;EAwNI,wCAAA;AL8bJ;AA3pBA;EACE,8BAAA;EACA,2BAAA;EACA,sBAAA;AA6pBF;AA1pBA;EACE,YAAA;AA4pBF;AAzpBA;EACE,iBAAA;EACA,YAAA;EACA,iCAAA;AA2pBF;AAxpBA;EACE,YAAA;EACA,gBAAA;AA0pBF;AAvpBA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAypBF;AAtpBA;EACE,YAAA;EACA,iBAAA;AAwpBF;AAtpBA;EACE,uBAAA;AAwpBF;AArpBA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAupBF;AA9pBA;EASI,kBAAA;AAwpBJ;AAjqBA;EAYI,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AAwpBJ;AAvpBI;EAEE,qBAAA;EACA,UAAA;AAwpBN;AAtpBI;EACE,qBAAA;EACA,UAAA;AAwpBN;AA/qBA;EA2BI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAupBJ;AArrBA;EAiCI,uBAAA;EACA,YAAA;EACA,4BAAA;AAupBJ","sourcesContent":["@import \"normalize.less\";\n@import \"sidebars.less\";\n@import \"nowebcasts.less\";\n@import \"videojs.less\";\n@import \"livescore.less\";\n\n@navbar-height: 50px;\n\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  background: black;\n  height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n#content {\n  height: 100%;\n  overflow: hidden;\n}\n\n.container-full {\n  position: relative;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n#twitter-widget {\n  height: 100%;\n  background: white;\n}\niframe[id^='twitter-widget-'] {\n  height: 100% !important;\n}\n\n.layout-selection-panel {\n  max-width: 800px;\n  height: 100%;\n  margin: auto;\n  padding: 0 15px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  color: white;\n  h1 {\n    text-align: center;\n  }\n  .layout-preview-container {\n    text-align: center;\n    padding-top: 20px;\n    cursor: pointer;\n    transition: all .15s ease-in-out;\n    &:hover {\n      //background-color: #444;\n      transform: scale(1.1);\n      z-index: 5;\n    }\n    &:active {\n      transform: scale(1.2);\n      z-index: 5;\n    }\n  }\n  .layout-preview {\n    width: 160px;\n    height: 90px;\n    position: relative;\n    display: inline-block;\n  }\n  div[class^=\"video-\"] {\n    background-color: white;\n    padding: 1px;\n    background-clip: content-box;\n  }\n}\n","/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\n\n/* Document\n   ========================================================================== */\n\nhtml {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\n\nfigcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */\n\na:active,\na:hover {\n  outline-width: 0;\n}\n\n/**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\n\ndetails, /* 1 */\nmenu {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\ncanvas {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\n\ntemplate {\n  display: none;\n}\n\n/* Hidden\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10-.\n */\n\n[hidden] {\n  display: none;\n}\n","@chat-sidebar-width: 300px;\n@hashtag-sidebar-width: 300px;\n\n.chat-sidebar {\n  position: absolute;\n  right: 0;\n  width: @chat-sidebar-width;\n  height: 100%;\n  background: #EFEEF1\n}\n\n.hashtag-sidebar {\n  position: absolute;\n  left: 0;\n  width: @hashtag-sidebar-width;\n  height: 100%\n}\n\n.content {\n  position: absolute;\n  left: 0;\n  right: 0;\n  // TODO make this dynamic based on app bar height\n  top: 64px;\n  bottom: 0px;\n  &.leave-right-margin {\n    margin-right: 300px;\n  }\n\n  &.leave-left-margin {\n    margin-left: 300px;\n  }\n}\n",".no-webcasts-container {\n  max-width: 800px;\n  height: 100%;\n  margin: auto;\n  padding: 0 15px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  color: white;\n  text-align: center;\n  > * {\n    margin-bottom: 69px;\n  }\n}\n","// Fixes inability of video.js to stretch to fill a container\n.video-js {\n  width: 100% !important;\n  height: 100% !important;\n}\n","@gray: #222;\n\n.livescore-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.livescore-container {\n  margin: 0 auto;\n}\n\n.livescore-display {\n  width: 400px;  // This will get resized, but defines aspect ratio\n  padding: 15px;\n  text-align: center;\n  color: white;\n\n  h3 {\n    margin-top: 0;\n  }\n\n  .col-container {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .side-col {\n    flex-grow: 1;\n  }\n\n  .mid-col {\n    flex-grow: 1;\n    padding: 0 10px;\n  }\n\n  .booleanIndicator {\n    border: solid 1px #ccc;\n    border-radius: 3px;\n    margin-bottom: 8px;\n    background-color: @gray;\n  }\n\n  .powerupsContainer {\n    display: flex;\n    margin-bottom: 8px;\n  }\n\n  .powerupCountContainer {\n    flex: 1;\n    border: solid 1px #ccc;\n    border-radius: 3px;\n    padding: 3px;\n    background-color: @gray;\n  }\n\n  .powerupCountContainerCenter {\n    margin-left: 3px;\n    margin-right: 3px;\n  }\n\n  .powerupIcon {\n    height: 25px;\n    width: 25px;\n    margin: 0;\n    image-rendering: optimizeSpeed;             /* STOP SMOOTHING, GIVE ME SPEED  */\n    image-rendering: -moz-crisp-edges;          /* Firefox                        */\n    image-rendering: -o-crisp-edges;            /* Opera                          */\n    image-rendering: -webkit-optimize-contrast; /* Chrome (and eventually Safari) */\n    image-rendering: pixelated;                 /* Chrome */\n    image-rendering: optimize-contrast;         /* CSS3 Proposed                  */\n    -ms-interpolation-mode: nearest-neighbor;   /* IE8+                           */\n  }\n\n  .powerCube {\n    width: 12px;\n    height: 12px;\n    margin: 3px auto 0;\n  }\n\n  .powerCubeActive {\n    background-color: #ffcf08;\n    border: 1px solid #111;\n    border-radius: 2px;\n  }\n\n  .timeRemainingContainer {\n    width: 100%;\n    position: absolute;\n    left: 0;\n  }\n\n  .timeRemaining {\n    background-color: rgba(63; 63; 63; 0.5);\n    padding: 0 5px;\n    border-radius: 3px;\n  }\n\n  .scoreContainer {\n    display: flex;\n    margin-bottom: 8px;\n  }\n\n  .redAlliance {\n    flex: 1;\n    margin-right: 2px;\n  }\n\n  .blueAlliance {\n    flex: 1;\n    margin-left: 2px;\n  }\n\n  .score {\n    border: solid 1px #ccc;\n    border-radius: 3px;\n    font-size: 18px;\n    font-weight: bold;\n    padding: 1px;\n    margin-top: 8px;\n  }\n\n  .currentPowerup {\n    border: solid 1px #ccc;\n    border-radius: 3px;\n    font-size: 14px;\n    margin: 0 auto;\n    padding: 1px;\n    width: 40px;\n  }\n\n  .currentPowerupIcon {\n    width: 20px;\n    height: 20px;\n    margin: 2px auto;\n    image-rendering: optimizeSpeed;             /* STOP SMOOTHING, GIVE ME SPEED  */\n    image-rendering: -moz-crisp-edges;          /* Firefox                        */\n    image-rendering: -o-crisp-edges;            /* Opera                          */\n    image-rendering: -webkit-optimize-contrast; /* Chrome (and eventually Safari) */\n    image-rendering: pixelated;                 /* Chrome */\n    image-rendering: optimize-contrast;         /* CSS3 Proposed                  */\n    -ms-interpolation-mode: nearest-neighbor;   /* IE8+                           */\n  }\n\n  .blue {\n    background-color: #0066FF;\n  }\n\n  .red {\n    background-color: #FF0000;\n  }\n\n  .progress {\n    height: 20px;\n    margin-bottom: 8px;\n    border: solid 1px #ccc;\n    border-radius: 3px;\n    background-color: @gray;\n  }\n\n  .progress-bar {\n    float: left;  // Remove from flow\n    height: 100%;\n    border-radius: 2px;\n  }\n\n  .progress-bar-red {\n    background-color: red;\n  }\n\n  .progress-bar-yellow {\n    background-color: yellow;\n  }\n\n  .progress-bar-green {\n    background-color: green;\n  }\n\n  @keyframes highlightRed1 {\n    0%   { background-color: #880000; }\n    100% { background-color: @gray; }\n  }\n\n  @keyframes highlightRed2 {\n    0%   { background-color: #880000; }\n    100% { background-color: @gray; }\n  }\n\n  @keyframes highlightRed3 {\n    0%   { background-color: #880000; }\n    100% { background-color: @gray; }\n  }\n  @keyframes highlightBlue1 {\n    0%   { background-color: #003388; }\n    100% { background-color: @gray; }\n  }\n\n  @keyframes highlightBlue2 {\n    0%   { background-color: #003388; }\n    100% { background-color: @gray; }\n  }\n\n  @keyframes highlightBlue3 {\n    0%   { background-color: #003388; }\n    100% { background-color: @gray; }\n  }\n\n  .redCount1 {\n    animation: highlightRed1 1s ease-in-out;\n  }\n\n  .redCount2 {\n    animation: highlightRed2 1s ease-in-out;\n  }\n\n  .redCount3 {\n    animation: highlightRed3 1s ease-in-out;\n  }\n\n  .blueCount1 {\n    animation: highlightBlue1 1s ease-in-out;\n  }\n\n  .blueCount2 {\n    animation: highlightBlue2 1s ease-in-out;\n  }\n\n  .blueCount3 {\n    animation: highlightBlue3 1s ease-in-out;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
